import React, { useEffect, useContext, useState, useRef } from 'react'
import FinDeFormation from "../../../components/ui/Formats/FinDeFormation"
import { fondDeLEcran } from "../../../components/ui/Formats/FormatsHelpers"
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@mui/material';

import APIS from "../../../utils/APIS"

import SuperAdminContext from "../../../contexts/SuperAdminContext"
import UserContext from "../../../contexts/UserContext"
import { FormeAdresseProvider } from "../../../contexts/FormeAdresseContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import SideBar from "../../../components/ui/Admin/Formations/SideBar"

import ScaleThumbForm from "../../../components/ui/Formation/ScaleThumbForm"
import { FormatSwitch } from "../../../pages/Formation"

/* ⛔ POURQUOI CETTE VUE EXISTE (09/09/2026).
   Nawal voyait « beaucoup de differences » entre son apercu d'admin et ce que
   l'apprenant a vraiment sous les yeux, et se recreait donc un compte etudiant
   a chaque verification. Trois causes, mesurees :
     1. l'apercu est une VIGNETTE : `ScaleThumbForm` rend l'ecran dans une boite
        FIXE de 1500 x 1000 puis la reduit par `transform: scale()` ;
     2. cette boite est forcee au format 3:2 (`aspectRatio: 1.5`), alors qu'un
        ecran d'apprenant fait plutot 16:9 — la colonne de texte et l'image
        n'ont donc pas les memes proportions ;
     3. `isEditor` ajoute les outils d'edition, que l'apprenant ne voit jamais.
   La vue ci-dessous supprime les trois d'un coup : plein ecran, aux vraies
   dimensions de la fenetre, sans `isEditor` et sans mise a l'echelle. C'est
   le meme composant que le lecteur apprenant, rendu dans les memes conditions.
   Elle ne remplace pas un compte etudiant pour TESTER une progression : elle
   remplace le compte etudiant qu'on creait juste pour REGARDER. */

const FormationPlayer = () => {
  const navigate = useNavigate()
  const params = useParams();

  const {
    contents,
    updateAdminContents,
    content,
    setContent,
    playerHasChanged,
    setPlayerHasChanged,
    setOverlayForSave,
    adminPlayerIndexes,
    setAdminPlayerIndexes,
  } = useContext(SuperAdminContext)

  const setActContent = async () => {
    var findContent = contents?.find((l) => l.id.toString() == params?.id)

    if (findContent) {
      if (content == null || content.id !== findContent.id) {
        setOverlayForSave(true)
        let fetchContent = await APIS.getContentByIdForAdmin({id : findContent.id})
        if (fetchContent) {
          sessionStorage.setItem('saveFormationAdmin', JSON.stringify(fetchContent));
          setAdminPlayerIndexes({ chapitre: 0, partie: 0, sequence: 0 })
          setPlayerHasChanged(false)
          setContent(fetchContent)
          setOverlayForSave(false)
        } else {
          navigate("/admin/formation")
        }
      }
    } else {
      navigate("/admin/formation")
    }
  }

  useEffect(() => {
    if (params?.id && contents) {
      setActContent()
    }
  }, [contents, params])

  /*useEffect(() => {
    console.log("content change useEffect")
  }, [content])*/

  const [sequenceSubMenu, setSequenceSubMenu] = useState(false)
  /* ⛔ OUVERTURE DIRECTE EN VUE APPRENANT (21/09/2026). L'apercu multi-tailles
     charge CE MEME ecran dans un iframe dimensionne a 1512 / 834 / 393. Pour
     que le vrai responsive s'applique, il faut une vraie fenetre : les formats
     utilisent `useMediaQuery`, qui repond a la FENETRE et non au conteneur.
     L'iframe doit donc pouvoir ouvrir la vue apprenant sans clic, d'ou ce
     parametre d'URL. Il ne fait qu'ouvrir une vue : aucun effet metier. */
  const [vueApprenant, setVueApprenant] = useState(
    () => { try { return new URLSearchParams(window.location.search).get('vueApprenant') === '1' } catch (e) { return false } }
  )

  /* ⛔ APERCU MULTI-TAILLES (21/09/2026). Trois boutons qui contraignent le VRAI
     renderer, pas un CSS d'apercu : le lecteur est charge dans un iframe de meme
     origine, dimensionne a la taille de reference. Les formats utilisent
     `useMediaQuery`, qui repond a la FENETRE et non au conteneur — sans vraie
     fenetre, les branches `xs`/`sm` ne se declencheraient jamais et l'apercu
     mentirait. L'iframe est simplement mis a l'echelle pour tenir dans le
     panneau : la mise a l'echelle est visuelle, la fenetre reste vraie. */
  const TAILLES_APERCU = {
    desktop : { l: 1512, h: 982,  nom: "Desktop" },
    tablet  : { l: 834,  h: 1194, nom: "Tablet"  },
    mobile  : { l: 393,  h: 855,  nom: "Mobile"  },
  }
  /* ⛔ L'ECHELLE TIENT COMPTE DES DEUX DIMENSIONS. Premiere version : seule la
     largeur comptait. En Mobile, 393 px de large ne declenchaient aucune
     reduction, et les 855 px de haut sortaient du panneau — le bas de l'ecran,
     donc la pastille et le CTA, etaient coupes. Constate a l'image, pas a la
     mesure : la mesure disait « fenetre 393 x 855 ✅ », ce qui etait vrai et
     insuffisant. */
  const APERCU_L_MAX = 460
  const APERCU_H_MAX = 430
  const echelleApercu = (k) => Math.min(
    1,
    APERCU_L_MAX / TAILLES_APERCU[k].l,
    APERCU_H_MAX / TAILLES_APERCU[k].h,
  )
  const [apercuTaille, setApercuTaille] = useState(null)
  /* Defaut : VUE APPRENANT STANDARD. Le mode editorial ne doit jamais etre
     actif sans qu'on l'ait demande ici, et il ne persiste pas. */
  /* La liste de modes a disparu avec la vue editoriale (arbitrage du 21/09) :
     il n'y a plus qu'un rendu, celui des planches. */
  /* ⛔ LE PLAN DE LA VUE APPRENANT (21/09/2026). Hicham : « ca met erreur
     quand je clique ». Cause mesuree : `FormatSwitch` ne recevait ici que
     `actFormation`, `format` et `actIndex`, alors que le vrai lecteur
     (`Formation.js`) lui passe AUSSI `actPlan`, `viewPlanCours` et
     `setViewPlanCours`. La barre du haut appelle `setViewPlanCours(true)`
     (FormatsHelpers.js) quand on deplie le nom du chapitre : sans la fonction,
     l'appel levait et l'ecran tombait en erreur.
     On ne neutralise PAS le bouton, on lui donne un vrai etat local : la vue
     doit rester fidele, donc le plan doit s'ouvrir comme chez l'apprenant.
     L'etat est propre a l'apercu et n'ecrit aucune progression. */
  /* ⛔ L'ESSAI JETABLE (21/09/2026). Deux regimes distincts dans cette vue,
     et il ne faut pas les melanger :
       PARCOURIR — les fleches du bas, pilotees par `adminPlayerIndexes`.
         Rien n'est interactif, rien n'est enregistre. Pour relire des ecrans.
       ESSAYER — le lecteur est pilote par le CONTEXTE APPRENANT, exactement
         comme dans `Formation.js`. Les reponses se valident, la progression
         avance, l'ecran de fin calcule un vrai resultat. Rien n'est enregistre
         non plus : `saveUserFormation` est coupee cote contexte.
     Les fleches sont donc MASQUEES pendant un essai : deux systemes de
     navigation concurrents sur le meme ecran, c'est un bug garanti. */
  const {
    actFormation : formationEssai,
    actIndex : indexEssai,
    actPlan : planEssai,
    essai,
    demarrerEssai,
    arreterEssai,
    marquerApercuAdmin,
  } = useContext(UserContext)

  /* ⛔ B58 (25/09/2026) : TOUT CE QUE CETTE PAGE REND DU LECTEUR EST UN APERCU.
     « Plein ecran » et « Fin de module (simulee) » ne posaient pas
     `vueApprenant=1` dans l'adresse : un clic dans la vue apprenant passait par
     l'enregistrement normal (boite « Erreur ! », ou progression de l'admin
     enregistree s'il suivait le meme module). Plutot que de reecrire l'adresse
     a chaque ouverture et a chaque sortie (Quitter, Echap, et celles qu'on
     ajoutera), la page le signale au contexte tant qu'elle est affichee, et le
     retire en partant. La vignette de l'editeur, qui porte un vrai bouton
     « Demarrer », est couverte du meme coup.
     L'essai n'est pas concerne : le contexte le teste AVANT l'apercu et le
     laisse suivre son propre chemin (rien n'est enregistre non plus). */
  /* (26/09/2026) En partant, la page arrete aussi l'essai. « Quitter » et Echap
     l'arretaient, mais pas les autres sorties (« Retour au tableau de bord » de
     la fin d'essai, la croix du bandeau, le retour du navigateur) : l'essai
     restait actif, et les reponses de l'admin sur son propre parcours
     n'etaient plus enregistrees, sans aucun message, jusqu'au rechargement.
     `arreterEssai` ne fait rien hors essai. */
  useEffect(() => {
    marquerApercuAdmin(true)
    return () => { marquerApercuAdmin(false); arreterEssai() }
  }, [])

  const formatEssai = formationEssai?.chapitre?.[indexEssai?.chapitre]?.partie?.[indexEssai?.partie]?.sequence?.[indexEssai?.sequence]

  const lancerEssai = () => {
    setApercuFin(false)
    demarrerEssai(content, planSimule)
    setVueApprenant(true)
  }

  /* ⚠️ UNE SEULE SORTIE. Tout ce qui ferme la vue doit arreter l'essai, sinon
     le contexte garderait le module a la place de la formation de l'admin. */
  const fermerVueApprenant = () => {
    arreterEssai()
    setApercuFin(false)
    setVueApprenant(false)
  }

  const [apercuPlan, setApercuPlan] = useState(false)
  /* ⛔ LE VOILE DE CHARGEMENT (21/09/2026). Hicham : « en vue editoriale ca me
     met la vue admin avec les modules ». L'apercu charge l'APPLICATION ADMIN
     ENTIERE dans l'iframe, et l'ecran apprenant ne s'y pose qu'une fois le
     contenu recupere (`vueApprenant && content`). Changer de mode change
     l'adresse de l'iframe, donc la recharge de zero : le temps de la requete,
     `content` est vide, l'overlay n'existe pas, et on voit la page admin.
     Ce n'est pas un rendu editorial casse, c'est le rechargement qu'on regarde.
     On masque donc l'iframe tant qu'elle n'a pas fini de charger.
     ⚠️ Remis a faux a CHAQUE changement d'adresse, sinon le voile ne
     reviendrait qu'au premier chargement. */
  const [apercuPret, setApercuPret] = useState(false)
  useEffect(() => { setApercuPret(false) }, [apercuTaille])
  const lienApercu = () => {
    try {
      const u = new URL(window.location.href)
      u.searchParams.set("vueApprenant", "1")
      return u.pathname + u.search
    } catch (e) { return null }
  }

  /* ⛔ APERCU DE LA FIN DE MODULE — ETAT SIMULE, STRICTEMENT EN MEMOIRE.
     Cet ecran n'existe pas comme contenu : il est GENERE a partir des resultats,
     d'ou son inaccessibilite depuis l'apercu. Le rendre visible ne demande
     pourtant aucune ecriture : `FinDeFormation` ne calcule et n'enregistre que
     si `resultFin` est NUL (voir la condition ligne 120 du composant). Des lors
     qu'on lui fournit un `resultFin`, il se contente d'AFFICHER.
     On lui passe donc une copie locale de la formation, jamais persistee :
     aucune ecriture en base, aucune progression, aucun resultat cree, aucun
     compte modifie. Les valeurs sont visiblement fictives pour qu'on ne les
     confonde pas avec un vrai resultat. */
  const [apercuFin, setApercuFin] = useState(false)
  const RESULTAT_SIMULE = {
    glbMaster : { score: 87 },
    "Flexibilite mentale" : { score: 87 },
    "Raisonnement logique" : { score: 72 },
    "Empathie" : { score: 64 },
  }
  const formationSimulee = content ? {
    ...content,
    isDone : true,
    resultFin : JSON.stringify(RESULTAT_SIMULE),
  } : null
  const planSimule = content ? [{ id: content.id, softSkillsFromContent: [] }] : null

  /* La liste a plat de tous les ecrans du module, dans l'ordre de lecture.
     Elle sert uniquement aux fleches de la vue apprenant : la vue d'edition
     continue de naviguer par la barre laterale. */
  const ecrans = []
  content?.chapitre?.forEach((ch, ci) =>
    ch?.partie?.forEach((pa, pi) =>
      pa?.sequence?.forEach((se, si) =>
        ecrans.push({ chapitre: ci, partie: pi, sequence: si }))))

  const rang = ecrans.findIndex((e) =>
    e.chapitre === adminPlayerIndexes?.chapitre &&
    e.partie === adminPlayerIndexes?.partie &&
    e.sequence === adminPlayerIndexes?.sequence)

  /* ⚠️ ON SE DEPLACE PAR ECART, ET DEPUIS L'ETAT PRECEDENT. Une premiere
     version calculait le rang d'apres la valeur courante, puis appelait
     `setAdminPlayerIndexes(ecrans[rang + 1])`. Or React ne rend pas entre deux
     appuis rapproches : deux appuis sur la fleche repartaient du meme rang et
     n'avancaient que d'un ecran. Mesure au banc : 160 appuis, un seul ecran
     franchi. En passant une fonction, chaque appui part de l'etat que le
     precedent a pose, et la suite d'appuis se comporte comme on l'attend. */
  const allerDe = (ecart) => {
    setAdminPlayerIndexes((prec) => {
      const i = ecrans.findIndex((e) =>
        e.chapitre === prec?.chapitre && e.partie === prec?.partie && e.sequence === prec?.sequence)
      const n = i + ecart
      return (i >= 0 && n >= 0 && n < ecrans.length) ? ecrans[n] : prec
    })
  }

  /* Echap ferme la vue : c'est le geste attendu d'un plein ecran, et il evite
     de chercher la croix quand un ecran occupe toute la fenetre. */
  useEffect(() => {
    if (!vueApprenant) return
    const auClavier = (e) => {
      if (e.key === "Escape") { fermerVueApprenant(); return }
      /* ⚠️ PAS DE FLECHES QUAND ON ECRIT. Les ecrans de saisie portent un champ
         de texte : sans cette garde, deplacer le curseur dans sa reponse
         changeait d'ecran et perdait ce qui venait d'etre tape. */
      const cible = e.target
      const saisie = cible && (cible.tagName === "INPUT" || cible.tagName === "TEXTAREA" ||
                               cible.isContentEditable)
      if (saisie) return
      if (e.key === "ArrowRight") allerDe(1)
      if (e.key === "ArrowLeft") allerDe(-1)
    }
    window.addEventListener("keydown", auClavier)
    return () => window.removeEventListener("keydown", auClavier)
  }, [vueApprenant, ecrans.length])

  useEffect(() => {
    setSequenceSubMenu(false)
  }, [adminPlayerIndexes])


  /* La meme expression de quatre niveaux etait recopiee cinq fois dans ce
     rendu. Recopiee, elle se corrige quatre fois sur cinq : une vignette
     pointerait alors un ecran et en peindrait le fond d'un autre, sans erreur
     ni test rouge. Une seule lecture, un seul endroit a corriger. */
  const formatCourant = content?.chapitre[adminPlayerIndexes?.chapitre]?.partie[adminPlayerIndexes?.partie]?.sequence[adminPlayerIndexes?.sequence]

  /* Tutoiement / vouvoiement (07/10/2026) : les ecrans d'apprenant rendus ici
     (apercu, plein ecran, essai, fin simulee) suivent la cible du module
     regarde, comme chez l'apprenant. Les textes de l'admin eux-memes ne lisent
     pas ce contexte et ne changent pas. */
  return (
    <FormeAdresseProvider cible={content?.cible}>
      <Helmet>
        <title>Admin Modules | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >

          {content &&
            <Box sx={{
              height:"calc(100vh - 105px)",
              display:"flex",
              overflow:"hidden",
              gap:"10px"
            }}>
              <SideBar
                content={content}
                setContent={setContent}
                actIndex={adminPlayerIndexes}
                setIndex={setAdminPlayerIndexes}
                sequenceSubMenu={sequenceSubMenu}
                setSequenceSubMenu={setSequenceSubMenu}
              />

              <Box sx={{
                height:"100%",
                width:"calc(100vw - 250px)",
                overflow:"hidden",
                display:"flex",
                flexDirection:"column",
                alignItems:"center",
                justifyContent:"center",
                gap:"10px"
              }}>
                <Box sx={{ display:"flex", flexDirection:"column", gap:"8px", alignSelf:"stretch", alignItems:"flex-end",
          /* ⛔ COLLANTE, ET C'EST UN CORRECTIF. Capture d'Hicham du 21/09 a
             16h23 : des qu'un apercu etait ouvert, TOUTE la barre disparaissait.
             Elle n'etait pas cassee — elle etait ROGNEE au-dessus par le
             conteneur, qui coupe ce qui depasse. D'ou « je ne peux plus revenir
             aux autres modes » : les boutons existaient, hors du cadre visible.
             ⚠️ Mon script automatique ne l'avait pas vu : il interrogeait
             `isVisible()`, qui repond vrai pour un element rogne par un parent.
             La capture, elle, ne ment pas. */
          position:"sticky", top:0, zIndex:5, backgroundColor:"#FFFFFF", paddingBottom:"8px" }}>
                  {/* ⛔ DEUX LISTES, PAS SEPT BOUTONS (21/09/2026, demande d'Hicham).
                      Les sept boutons tenaient sur deux rangees et se disputaient la
                      largeur : c'est ce qui a permis a la barre entiere d'etre rognee
                      sans qu'on le voie. Une liste occupe une largeur FIXE quel que
                      soit le nombre de choix, donc la barre ne peut plus grandir.
                      Le mode reste ECRIT en toutes lettres dans la liste : c'est tout
                      l'objet du correctif d'origine, ne jamais avoir a deviner le
                      rendu qu'on regarde. */}
                  <Box sx={{ display:"flex", gap:"8px", alignItems:"center", flexWrap:"wrap", justifyContent:"flex-end" }}>
                    <Box component="select"
                      value={apercuTaille || ""}
                      onChange={(e) => setApercuTaille(e.target.value || null)}
                      sx={{ font:"inherit", fontSize:"13px", padding:"5px 8px", borderRadius:"4px",
                            border:"1px solid rgba(0,0,0,0.3)", backgroundColor:"#FFFFFF", cursor:"pointer" }}>
                      <option value="">Aperçu fermé</option>
                      {Object.keys(TAILLES_APERCU).map((k) => (
                        <option key={k} value={k}>
                          {TAILLES_APERCU[k].nom + " \u00b7 " + TAILLES_APERCU[k].l + " x " + TAILLES_APERCU[k].h}
                        </option>
                      ))}
                    </Box>

                    {/* Les ACTIONS restent des boutons : elles ne decrivent pas un etat,
                        elles declenchent quelque chose. L'ecran de Fin de module n'est
                        pas un contenu : il se voit sur un resultat SIMULE en memoire,
                        jamais enregistre. */}
                    <Button variant="outlined" size="small" onClick={() => setVueApprenant(true)} sx={{ textTransform:"none" }}>
                      Plein écran
                    </Button>
                    <Button variant="contained" size="small" onClick={lancerEssai}
                      sx={{ textTransform:"none" }}>
                      Tester le module
                    </Button>
                    <Button variant={apercuFin ? "contained" : "outlined"} size="small"
                      onClick={() => { arreterEssai(); setApercuFin(true); setVueApprenant(true) }} sx={{ textTransform:"none" }}>
                      Fin de module (simulée)
                    </Button>
                  </Box>
                {apercuTaille && lienApercu() &&
                  <Box sx={{ alignSelf:"stretch" }}>
                    {/* ⛔ IFRAME DE MEME ORIGINE, PAS UN CSS D'APERCU. Le lecteur y tourne
                        avec SA PROPRE FENETRE, donc `useMediaQuery` voit bien 1512, 834 ou
                        393 et les vraies branches responsive s'appliquent. La mise a
                        l'echelle ci-dessous est purement visuelle : elle fait tenir l'apercu
                        dans le panneau sans toucher a la taille de la fenetre. */}
                    <Box sx={{
                      width: Math.round(TAILLES_APERCU[apercuTaille].l * echelleApercu(apercuTaille)) + "px",
                      height: Math.round(TAILLES_APERCU[apercuTaille].h * echelleApercu(apercuTaille)) + "px",
                      overflow:"hidden", border:"1px solid black", margin:"0 auto",
                      position:"relative",
                    }}>
                      {!apercuPret &&
                        <Box sx={{ position:"absolute", top:0, left:0, right:0, bottom:0,
                                   display:"flex", alignItems:"center", justifyContent:"center",
                                   backgroundColor:"#FFFFFF", fontSize:"13px", color:"rgba(0,0,0,0.5)" }}>
                          Chargement de l'apercu...
                        </Box>
                      }
                      <Box component="iframe"
                        title={"Aperçu " + TAILLES_APERCU[apercuTaille].nom}
                        src={lienApercu()}
                        onLoad={() => setApercuPret(true)}
                        sx={{
                          visibility: apercuPret ? "visible" : "hidden",
                          width: TAILLES_APERCU[apercuTaille].l + "px",
                          height: TAILLES_APERCU[apercuTaille].h + "px",
                          border:"none", display:"block",
          /* ⛔ APERCU NON INTERACTIF (21/09/2026). Hicham : « en mode tablet je
             ne peux plus revenir aux autres modes, en mobile ca bugge direct ».
             Non reproduit en automatique a 1512 ni a 1916 — les trois boutons
             restent visibles et cliquables, aucune erreur JS. Le cas qui manque
             est le clic DANS l'apercu : l'iframe charge la page admin avec
             `vueApprenant=1`, et un clic a l'interieur pouvait y naviguer ou
             refermer la vue, donnant une page admin imbriquee — de quoi croire
             que tout est casse. Un apercu n'a pas a etre pilotable : on coupe
             les evenements. Pour naviguer, « Plein ecran » est la pour ca. */
          pointerEvents:"none",
                          transform: "scale(" + echelleApercu(apercuTaille) + ")",
                          transformOrigin:"top left",
                        }}
                      />
                    </Box>
                    <Box sx={{ fontSize:"12px", color:"rgba(0,0,0,0.6)", textAlign:"center", marginTop:"6px" }}>
                      {TAILLES_APERCU[apercuTaille].nom} · {TAILLES_APERCU[apercuTaille].l} x {TAILLES_APERCU[apercuTaille].h} · vue apprenant
                    </Box>
                  </Box>
                }
                </Box>
                <Box sx={{
                  overflow:"hidden",
                  aspectRatio:"1.5",
                  maxHeight:"100%",
                  maxWidth:"100%",
                  border:"1px solid black"
                }}>
                  <ScaleThumbForm isEditor fond={fondDeLEcran(formatCourant)}>
                    <FormatSwitch
                apercuAdmin
                      actFormation={content}
                      format={formatCourant}
                      actIndex={adminPlayerIndexes}
                      onlyContent
                      isEditor
                      sequenceSubMenu={sequenceSubMenu}
                      setSequenceSubMenu={setSequenceSubMenu}
                    />
                  </ScaleThumbForm>
                </Box>
              </Box>
            </Box>
          }

        </Box>
      </Box>

      {vueApprenant && content &&
        <Box sx={{
          position:"fixed",
          top:0, left:0, right:0, bottom:0,
          zIndex:1400,
          /* ⚠️ LE FOND SUIT L'ECRAN REELLEMENT AFFICHE. Pendant un essai, c'est
             le contexte apprenant qui pilote : prendre `formatCourant`, qui suit
             l'index ADMIN, aurait pose le bon ecran sur le mauvais fond. Defaut
             attrape par le test `fond-ecran`, pas par l'oeil. */
          backgroundColor: fondDeLEcran(essai ? formatEssai : formatCourant),
        }}>
          {/* ⛔ LE MEME FOND QUE CHEZ L'APPRENANT. Sans lui la vue rendait le
              format sur du blanc : ni filigrane, ni degrade, ni grain. Hicham
              l'a vu des la premiere ouverture. C'est tout l'objet de cette vue
              que d'etre fidele — un fond different suffit a la disqualifier.
              Lot G : « le meme fond » ne veut plus dire « toujours teinte ».
              Les ecrans de contenu sont blancs, les autres teintes, et les deux
              vues posent la question au MEME endroit, `fondDeLEcran`. */}
          {/* Lot H : decor retire, voir la note dans `Formation.js`. La vue
              « comme un apprenant » doit rester fidele, donc elle le retire aussi. */}

          {/* L'ecran occupe toute la fenetre, exactement comme chez l'apprenant.
              Pas de `ScaleThumbForm`, donc pas de boite de 1500 x 1000 ni de
              `transform: scale()` : les unites de mise en page se mesurent sur
              la vraie fenetre. Pas de `isEditor` non plus, donc aucun outil
              d'edition. */}
          {/* ⚠️ zIndex 3, COMME DANS `Formation.js`. Le grain de la couche de
              fond est en `zIndex: 2` : sans cet etage, il se poserait PAR-DESSUS
              l'ecran, et le format passerait derriere son propre decor. */}
          <Box sx={{ position:"relative", zIndex:3, width:"100%", height:"100%" }}>
            {/* ⛔ SURTOUT PAS `onlyContent` ICI (constat du 09/09).
                Ce drapeau ne veut pas dire « rendu sans decor » : il veut dire
                « je suis une VIGNETTE ». `FormatVideo` s'en sert pour ne PAS
                monter le lecteur —
                    {(onlyContent !== true || isEditor === true) && <ReactPlayer …
                — ce qui est juste dans une vignette de 149 px, et absurde en
                plein ecran. Hicham : « la video ne se lance pas ». Elle ne se
                lancait pas parce qu'elle n'existait pas.
                Sans ce drapeau, le format prend `100vh`, c'est-a-dire la
                fenetre, c'est-a-dire exactement cette boite : le rendu est
                celui de la page apprenant, bandeaux compris. */}
            {apercuFin ?
              <FinDeFormation
                actFormation={formationSimulee}
                actPlan={planSimule}
                actIndex={adminPlayerIndexes}
                format={formatCourant}
              />
            : essai ?
              /* ESSAI : pilote par le contexte apprenant, comme `Formation.js`.
                 `FormatSwitch` bascule lui-meme sur l'ecran de fin quand
                 l'index vaut « max ». */
              <FormatSwitch
                apercuAdmin
                actFormation={formationEssai}
                format={formatEssai}
                actIndex={indexEssai}
                actPlan={planEssai}
                viewPlanCours={apercuPlan}
                setViewPlanCours={setApercuPlan}
              />
            :
            <FormatSwitch
                apercuAdmin
              actFormation={content}
              format={formatCourant}
              actIndex={adminPlayerIndexes}
              actPlan={planSimule}
              viewPlanCours={apercuPlan}
              setViewPlanCours={setApercuPlan}
            />
            }
          </Box>

          {/* ⛔ LE JETABLE DOIT SE VOIR, SANS GENER (Hicham, 22/09/2026).
              Premiere version : une pastille large au centre, en zIndex 2. Deux
              defauts, et le second explique le premier.
              • Elle masquait le haut de l'ecran et faussait la lecture des
                espacements, ce qu'on est justement en train de verifier.
              • Ses boutons NE FONCTIONNAIENT PAS : le contenu de l'ecran est en
                zIndex 3, la pastille en 2. Elle se voyait la ou le fond est
                transparent, mais tous les clics passaient au travers et
                atterrissaient sur l'ecran. Visible n'est pas cliquable — encore
                une fois.
              Elle passe donc discrete en haut a droite, et AU-DESSUS. */}
          {essai &&
            <Box sx={{
              position:"absolute", top:"10px", right:"56px",
              zIndex:6,
              display:"flex", alignItems:"center", gap:"10px",
              padding:"4px 10px", borderRadius:"999px",
              backgroundColor:"rgba(10,10,11,0.72)", color:"#FFFFFF",
              fontSize:"11px", lineHeight:"16px", whiteSpace:"nowrap",
            }}>
              <span style={{ opacity:0.85 }}>Essai &middot; rien n&rsquo;est enregistr&eacute;</span>
              <Box component="button" onClick={lancerEssai}
                sx={{ all:"unset", cursor:"pointer", fontSize:"11px", textDecoration:"underline", "&:hover":{ opacity:0.8 } }}>
                Recommencer
              </Box>
              <Box component="button" onClick={fermerVueApprenant}
                sx={{ all:"unset", cursor:"pointer", fontSize:"11px", textDecoration:"underline", "&:hover":{ opacity:0.8 } }}>
                Quitter
              </Box>
            </Box>
          }

          {/* La barre de deplacement flotte au-dessus de l'ecran. L'apprenant
              avance en repondant ; ici on veut pouvoir parcourir le module sans
              rien remplir, d'ou ces fleches, qui n'existent que dans cette vue. */}
          <Box sx={{
            position:"absolute",
            bottom:"16px",
            left:"50%",
            transform:"translateX(-50%)",
            display:"flex",
            alignItems:"center",
            gap:"8px",
            padding:"6px 10px",
            borderRadius:"999px",
            backgroundColor:"rgba(0,0,0,0.72)",
            color:"#FFFFFF",
            fontSize:"13px",
            zIndex:1,
            /* Masquees pendant un essai : l'apprenant avance en repondant, et
               deux systemes de navigation sur le meme ecran se contrediraient. */
            ...(essai ? { display:"none" } : {}),
          }}>
            <Button
              size="small"
              disabled={rang <= 0}
              onClick={() => allerDe(-1)}
              sx={{ minWidth:"32px", color:"#FFFFFF", "&.Mui-disabled":{ color:"rgba(255,255,255,0.35)" } }}
            >
              {"\u2039"}
            </Button>
            <Box component="span" sx={{ userSelect:"none", whiteSpace:"nowrap" }}>
              {(rang < 0 ? 1 : rang + 1) + " / " + ecrans.length}
            </Box>
            <Button
              size="small"
              disabled={rang < 0 || rang >= ecrans.length - 1}
              onClick={() => allerDe(1)}
              sx={{ minWidth:"32px", color:"#FFFFFF", "&.Mui-disabled":{ color:"rgba(255,255,255,0.35)" } }}
            >
              {"\u203A"}
            </Button>
            <Button
              size="small"
              onClick={fermerVueApprenant}
              sx={{ color:"#FFFFFF", textTransform:"none" }}
            >
              Quitter
            </Button>
          </Box>
        </Box>
      }
    </FormeAdresseProvider>
  )
};

export default FormationPlayer;
